var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-t font-11"},[_c('div',{staticClass:"text-grey-8"},[_vm._v("Comitentes participantes:")]),_c('div',{staticClass:"flex row"},_vm._l((_vm.leilao.comitentes),function(comitente){return _c('comitente-leilao-stats',{key:comitente.id,attrs:{"comitente":comitente}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }